import * as React from "react";
import { DrawerContent } from "@/components/ui/drawer";
import { useSidebarState } from "@/services/context/SidebarContext";

const SIDEBAR_WIDTH_OPEN = 208;
const SIDEBAR_WIDTH_COLLAPSED = 52;

// Outside a SidebarProvider (tests, isolated renders) the sidebar counts as open.
const useSidebarStateSafe = () => {
  try {
    return useSidebarState();
  } catch {
    return null;
  }
};

/** DrawerContent sized against the app sidebar's current width. */
export const AppDrawerContent = React.forwardRef<
  React.ElementRef<typeof DrawerContent>,
  React.ComponentPropsWithoutRef<typeof DrawerContent>
>((props, ref) => {
  const isSidebarOpen = useSidebarStateSafe()?.isSidebarOpen ?? true;
  return (
    <DrawerContent
      ref={ref}
      sidebarOffset={
        isSidebarOpen ? SIDEBAR_WIDTH_OPEN : SIDEBAR_WIDTH_COLLAPSED
      }
      {...props}
    />
  );
});
AppDrawerContent.displayName = "AppDrawerContent";
